import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

interface MainPageTodoListItem {
  id: number;
  name: string;
  shareToken: string;
  pendingRequests: number;
  currentUserRole: 'reader' | 'writer' | 'owner';
}

@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatListModule, MatChipsModule, MatIconModule],
  templateUrl: './main-page.component.html',
  styleUrl: './main-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainPageComponent {
  @Input() todoLists: MainPageTodoListItem[] = [];
  @Input() activeListId: number | null = null;

  @Output() selectList = new EventEmitter<number>();

  onSelectList(listId: number): void {
    this.selectList.emit(listId);
  }
}
